// @need-translate
import dynamic from 'next/dynamic';
import {useRouter} from 'next/router';
import {findIndexOrNull} from '../../../../common/shared/utils/array';
import {PrevTermsLink} from '../../../../domain/policy/presentational/PrevTermsLink';

const TermsPaid_2022_11_11 = dynamic(() =>
  import('./TermsPaid-2022-11-11').then(module => module.TermsPaid)
);

const TermsPaid_2022_09_08 = dynamic(() =>
  import('./TermsPaid-2022-09-08').then(module => module.TermsPaid)
);

/**
 * @raon.c
 * https://github.kakaocorp.com/kakaopage/pageweb/blob/develop/packages/pageweb/src/policy/component/TermsPaid.tsx
 * 현재는 바로 직전 버전만 보여주고 있습니다.
 * 다음 버전을 보여주기 위해서는 아래 주석처리된 코드를 주석 해제하고 TermsPaidConfigList에 추가해주세요.
 */
// const TermsPaid_2022_06_30 = dynamic(() =>
//   import('./TermsPaid-2022-06-30').then(module => module.TermsPaid)
// );

// const TermsPaid_2019_09_25 = dynamic(() =>
//   import('./TermsPaid-2019-09-25').then(module => module.TermsPaid)
// );

const DEFAULT_TERMS_PAID_INDEX = 0;

export function TermsPaid() {
  const router = useRouter();
  const {pathParams} = router.query;
  const termsPaidType = pathParams?.[1];

  const TermsPaidIndex =
    findIndexOrNull(
      TermsPaidConfigList,
      ({title}) => title === termsPaidType
    ) || DEFAULT_TERMS_PAID_INDEX;

  const TermsPaidComponent = TermsPaidConfigList[TermsPaidIndex].component;

  let nextTermsPaidTitle = undefined;
  if (TermsPaidIndex + 1 < TermsPaidConfigList.length) {
    nextTermsPaidTitle = TermsPaidConfigList[TermsPaidIndex + 1].title;
  }

  const getNextTermsPaidLinkLabel = (nextTermsPaidTitle: string) => {
    const [year, month, day] = nextTermsPaidTitle.split('-');
    return `${year}년 ${month}월 ${day}일 유료서비스 이용약관 보기`;
  };

  return (
    <>
      <TermsPaidComponent />
      {nextTermsPaidTitle && (
        <PrevTermsLink
          url={`/policy/terms-paid/${nextTermsPaidTitle}`}
          linkLabel={getNextTermsPaidLinkLabel(nextTermsPaidTitle)}
        />
      )}
    </>
  );
}

const TermsPaidConfigList = [
  {title: '2022-11-11', component: TermsPaid_2022_11_11},
  {title: '2022-09-08', component: TermsPaid_2022_09_08},
  // {title: '2022-06-30', component: TermsPaid_2022_06_30},
  // {title: '2019-09-25', component: TermsPaid_2019_09_25},
];
